<template>
	<v-hover v-slot="{ hover }" close-delay="200" open-delay="200">
		<tr>
			<th width="30%">{{ metaKeyName(metaKey) }}</th>
			<td width="70%">
				<p v-text="metaTypeName(metaKey)" />
				<div v-if="metaKey.option_type != 'not_required'">
					<!-- {{metaKey.option_type}} -->
					<h6 class="text-body-2 font-weight-bold">選択肢（{{ optionName() }}）</h6>
					<p
						class="text-body-2"
						v-for="option in metaKey.daily_report_meta_options"
						:key="option.id"
						v-text="value(option)"
					/>
				</div>
				<span v-show="hover">
					<TemplateDeleteDialog
						v-if="editable"
						:key="metaKey.id"
						:openBtnDesign="['fab', 'outlined', 'absolute', 'right']"
						:openBtnColor="'red'"
						:onlyIcon="true"
						:openBtnStyle="{ top: 0 }"
						ref="deleteDialog"
					>
						<template v-slot:icon>
							<v-icon>mdi-delete</v-icon>
						</template>
						<template v-slot:text>
							<div class="py-2">
								アーカイブまたは削除すると元に戻すことはできず、項目がフォームにも表示されなくなります。
								<br />
								削除する場合は、このテンプレートを使用した過去を含む日報に項目が表示されなくなります。
								<br />
								アーカイブする場合は、このテンプレートを使用した過去の日報には項目が表示されます。
							</div>
						</template>
						<template v-slot:button>
							<v-row no-gutters justify="center">
								<v-btn class="ma-1" @click="deleteMetaKey" dense dark color="red">
									<v-icon class="mr-2">mdi-delete</v-icon> 削除する
								</v-btn>
								<v-btn class="ma-1" @click="archiveMetaKey" dense dark color="grey">
									<v-icon class="mr-2">mdi-archive</v-icon> アーカイブする</v-btn
								>
							</v-row>
						</template>
					</TemplateDeleteDialog>
				</span>
			</td>
		</tr>
	</v-hover>
</template>

<script>
import axios from "axios"
import moment from "moment/min/moment.min.js"

import errorHandling from "../../../helper/errorHandling"
import authenticate from "../../../helper/authenticate"

import TemplateDeleteDialog from "../../shared/TemplateDeleteDialog.vue"
export default {
	components: {
		TemplateDeleteDialog,
	},
	props: {
		metaKeyData: {
			id: {
				type: Number,
				required: false,
				default: null,
			},
			name: {
				type: String,
				required: true,
				default: null,
			},
			meta_type: {
				type: String,
				required: true,
				default: null,
			},
			required_flag: {
				type: Boolean,
				required: true,
				default: false,
			},
		},
		metaTypes: {
			type: Array,
			default: [],
			required: true,
		},
		optionTypes: {
			type: Array,
			required: true,
		},
		polymorphicOptions: {
			type: Array,
			required: true,
		},

		editable: {
			type: Boolean,
			default: false,
			required: true,
		},
	},
	methods: {
		deleteMetaKey() {
			const status = "deleted"
			this.updateStatus(status)
		},
		archiveMetaKey() {
			const status = "archived"
			this.updateStatus(status)
		},
		updateStatus(status) {
			const headers = authenticate.setHeader()
			const url = `/erp/v1/daily_report_meta_keys/${this.metaKey.id}`
			axios
				.patch(url, { daily_report_meta_key: { status } }, { headers })
				.then((res) => {
					let message = null
					if (res.data == "deleted") {
						message = "追加項目を削除しました。"
					} else if (res.data == "archived") {
						message = "追加項目をアーカイブしました。"
					}
					this.$store.dispatch("setFlash", {
						text: message,
						type: "notice",
					})
					this.$refs.deleteDialog.closeDialog()
					this.$emit("delete-meta-key", this.metaKey.id)
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		metaKeyName(metaKey) {
			// アーカイブ済みを表示する場合はコメント解除
			// if (metaKey.status == "available") {
			return metaKey.required_flag ? `${metaKey.name}（必須）` : metaKey.name
			// } else if (metaKey.status == "archived") {
			// 	return `${metaKey.name}（アーカイブ済み）`
			// }
		},
		metaTypeName(metaKey) {
			const type = this.metaTypes.find((t) => t.id == metaKey.meta_type)
			if (type == null) return null
			if (metaKey.meta_type == "association") {
				const association = this.polymorphicOptions.find((p) => p.id == metaKey.association_name)
				if (association == null) return null
				return `${type.name}(${association.name})`
			} else {
				return type.name
			}
		},
		 optionName(){
			const type = this.optionTypes.find((t)=>t.id == this.metaKey.option_type )
			return type ? type.name : null
		},
		value(option) {
			switch (this.metaKey.meta_type) {
				case "string":
					return option.value_string
				case "text":
					return option.value_text
				case "date":
					if (!option.value_date) return null
					return moment(option.value_date).format("YYYY/MM/DD")
				case "datetime":
					if (!option.value_datetime) return null
					return moment(option.value_datetime).format("YYYY/MM/DD HH:mm")
				case "time":
					if (!option.value_time) return null
					return moment(option.value_time).format("HH:mm")
				case "integer":
					if (!option.value_integer) return null
					return Number(option.value_integer).toLocaleString()
				case "float":
					if (!option.value_float) return null
					return Number(option.value_float).toLocaleString()
				case "boolean":
					if (option.value_boolean == true) {
						return `${this.metaKey.name}である`
					} else if (option.value_boolean == false) {
						return `${this.metaKey.name}ではない`
					} else {
						return null
					}
			}
		},
	},
	computed: {
		metaKey: {
			get() {
				return this.metaKeyData
			},
			set(newValue) {
				return this.$emit("update:metaKey", newValue)
			},
		},
	},
}
</script>

<style lang="scss" scoped>
tr {
	position: relative;
}
td {
	position: relative;
}
</style>